<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item>异常信息</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row class="top">
			<el-col :span="24">
				<el-button :size="$store.state.width<$store.state.minwidth?'mini':''" type="primary" icon="el-icon-download" @click="exportExcel()">导 出</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="top">
					<el-table
					  :data="tableData"
					  size="mini"
						class="table"
					  border
					  stripe>
						<el-table-column
						  prop="sensortype"
						  label="传感器类型"
						  header-align="center"
						  align="center">
						</el-table-column>
						<el-table-column
						  prop="abnormal"
						  label="异常值"
						  header-align="center"
						  align="center">
						</el-table-column>
						<el-table-column
						  prop="condition"
						  label="异常情况"
						  header-align="center"
						  align="center">
						</el-table-column>
						<el-table-column
						  prop="lower"
						  label="异常下限"
						  header-align="center"
						  align="center">
						</el-table-column>
						<el-table-column
						  prop="upper"
						  label="异常上限"
						  header-align="center"
						  align="center">
						</el-table-column>
						<el-table-column
						  prop="time"
						  label="出现时间"
						  header-align="center"
						  align="center">
						</el-table-column>
						<el-table-column
						  label="操作"
						  width="70"
						  header-align="center"
						  align="center">
						  <template slot-scope="scope">
							  <el-button type="text" @click="deleteE(scope.$index)">删除</el-button>
						  </template>
						</el-table-column>
					</el-table>
				</div>
			</el-col>
		</el-row>
		<el-row class="top ye">
			<el-col :span="24">
				<div>
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						background
						:current-page="currentPage4"
						:page-sizes="[10, 20, 30, 40]"
						:page-size="100"
						layout="total, sizes, prev, pager, next, jumper"
						:total="tableData.length"
						align="center">
					</el-pagination>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
	export default {
		data() {
			return {
				currentPage4: 1,
				tableData: [{
					sensortype: '空气温度',
					  abnormal: '20.5',
					  condition: '低于下限',
					  lower: '100',
					  upper: '200',
					  time: '2018-12-11 18:20:10'
					}, {
					  sensortype: '土壤温度',
					  abnormal: '20.5',
					  condition: '低于下限',
					  lower: '100',
					  upper: '200',
					  time: '2018-11-12 15:20:10'
					},{
					  sensortype: '空气温度',
					  abnormal: '200.5',
					  condition: '高于上限',
					  lower: '100',
					  upper: '200',
					  time: '2018-10-12 8:20:10'
					},{
					  sensortype: '空气湿度',
					  abnormal: '20.5',
					  condition: '低于下限',
					  lower: '50',
					  upper: '80',
					  time: '2018-12-12 18:20:10'
					},{
					  sensortype: '空气湿度',
					  abnormal: '92.5',
					  condition: '高于上限',
					  lower: '50',
					  upper: '80',
					  time: '2018-12-12 18:20:10'
					},{
					  sensortype: '空气温度',
					  abnormal: '20.5',
					  condition: '低于下限',
					  lower: '100',
					  upper: '200',
					  time: '2018-9-12 1:20:10'
					},{
					  sensortype: 'PH',
					  abnormal: '5',
					  condition: '低于下限',
					  lower: '6',
					  upper: '8',
					  time: '2018-8-12 8:20:10'
					},{
					  sensortype: 'PH',
					  abnormal: '10',
					  condition: '高于上限',
					  lower: '6',
					  upper: '8',
					  time: '2018-7-12 10:20:10'
					},{
					  sensortype: '风速',
					  abnormal: '0',
					  condition: '低于下限',
					  lower: '2',
					  upper: '10',
					  time: '2018-01-12 18:55:10'
					}, {
					  sensortype: '风速',
					  abnormal: '20.5',
					  condition: '高于上限',
					  lower: '2',
					  upper: '10',
					  time: '2018-05-12 5:25:10'
					},{
					  sensortype: '水温',
					  abnormal: '-20.5',
					  condition: '低于下限',
					  lower: '0',
					  upper: '50',
					  time: '2018-12-12 18:20:10'
					},{
					  sensortype: '水温',
					  abnormal: '60',
					  condition: '高于上限',
					  lower: '0',
					  upper: '50',
					  time: '2017-12-15 23:45:19'
					}]
			}
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			deleteE(index)
			{
				this.tableData.splice(index,1);
				this.$message({message: '成功删除第'+(index+1)+'行！',type: 'success'});
			},
			exportExcel () {
				/* npm install --save xlsx file-saver 需要获取依赖 */
				var wb = XLSX.utils.table_to_book(document.querySelector('.table'))
				/* get binary string as output */
				var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
				try {
					FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
				} catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
				this.$message({message: '导出成功！',type: 'success'});
				return wbout
			}
		}
	}
</script>

<style scoped>
	.width{
		width: 92%;
		margin: auto;
	}
	.title{
		text-align: center;
		margin-top: -10px;
	}
	.top{
		margin-top: 10px;
	}
	.ye{
		width: 100%;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			padding-left: 5px;
		}
	}
</style>
